module.exports = __webpack_public_path__ + "img/14.2a2ddd2e.jpg";